// modules
import { listen } from 'weblite-router'
import { SessionStorageKeys } from '$logic/client-device/types'
import { handleLocationSearch, setGAPage } from './helper'
import {
  sessionStorageGetItem,
  sessionStorageSetItem,
} from '$func/session-storage'

export function initiateRouterListener() {
  // NOTE: After the history has been initiated, the next line codes should be executed.
  const refreshCount =
    sessionStorageGetItem(SessionStorageKeys.REFRESH_COUNT) || 0
  handleLocationSearch(window.location.search)
  sessionStorageSetItem(SessionStorageKeys.REFRESH_COUNT, refreshCount + 1)

  listen(() => {
    setGAPage()
  })
}
